import React from 'react';
import { SmartphoneIcon, HeadsetIcon, CheckCircle2Icon, QuoteIcon, BadgeCheckIcon } from 'lucide-react';
export function SocialValidation() {
  return <section className="py-12 bg-surface-elevated relative overflow-hidden" data-id="element-129">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-130"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        {/* --- AUTHOR STORY SECTION --- */}
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-24" data-id="element-132">
          <div className="lg:w-1/2 relative" data-id="element-133">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold/20 rounded-full blur-2xl" data-id="element-134"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-red-600/10 rounded-full blur-2xl" data-id="element-135"></div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white text-center mb-6" data-id="element-136">
              Eduardo Higueras{' '}
              <span className="text-gold" data-id="element-137">
                — Creador de "Carisma al Instante"
              </span>
            </h2>
            <div className="relative rounded-2xl overflow-hidden border border-gold/30 shadow-2xl shadow-gold/10" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/2uRn22ZeB9tzv3vguf3GLX/210542ee-dbcf-4211-97ae-14c89ea1643c.png" alt="Eduardo Higueras - Creador de Carisma al Instante" className="w-full h-auto object-cover aspect-[4/5]" data-id="element-139" />
              <div className="absolute inset-0 bg-gradient-to-t from-surface-deepest via-transparent to-transparent opacity-80" data-id="element-140"></div>
            </div>
          </div>

          <div className="lg:w-1/2" data-id="element-141">
            <QuoteIcon className="w-12 h-12 text-gold/20 mb-6" data-id="element-142" />
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-143">
              No nací con el "Don" del Carisma.{' '}
              <span className="text-gold italic" data-id="element-144">
                Tuve que construirlo desde cero.
              </span>
            </h2>

            <div className="space-y-4 font-body text-gray-300 text-lg leading-relaxed" data-id="element-145">
              <p data-id="element-146">
                Hola, soy el creador de este protocolo. Durante años, fui el
                hombre invisible en las reuniones. Ese tipo que tiene grandes
                ideas pero que nadie escucha, o que se queda en la esquina de la
                barra esperando que alguien se acerque a hablarle.
              </p>
              <p data-id="element-147">
                Me cansé de ser el tipo que siempre escuchaba "eres muy lindo,
                pero..." y decidí descifrar por qué algunos hombres atraen
                naturalmente mientras otros son ignorados. Me obsesioné con la
                Psicología Social Aplicada y descubrí que el carisma no es un
                talento místico,{' '}
                <span className="text-white font-bold" data-id="element-148">
                  es un sistema de señales.
                </span>
              </p>
              <p data-id="element-149">
                Sistematicé los 17 activadores que me permitieron pasar de la
                timidez paralizante a dominar cualquier sala. Hoy, más de 2,400
                hombres han usado estas mismas reglas para transformar su vida
                social. No es magia, es diseño de comportamiento.
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-surface-border" data-id="element-150">
              <p className="font-body text-gray-400 text-sm uppercase tracking-widest mb-4" data-id="element-151">
                Atentamente:
              </p>
              <p className="text-gold text-3xl md:text-4xl mb-1" style={{
              fontFamily: "'Dancing Script', cursive"
            }} data-id="element-152">
                Eduardo Higueras
              </p>
              <div className="flex items-center gap-3" data-id="element-153">
                <div className="w-8 h-px bg-gold/40" data-id="element-154"></div>
                <span className="text-gold/40 text-lg" data-id="element-155">✦</span>
                <div className="w-24 h-px bg-gold/40" data-id="element-156"></div>
                <span className="text-gold/40 text-lg" data-id="element-157">✦</span>
                <div className="w-8 h-px bg-gold/40" data-id="element-158"></div>
              </div>
            </div>
          </div>
        </div>

        {/* --- DELIVERABLES / OFFER STACK SECTION --- */}
        <div id="deliverables-section" className="pt-10 border-t border-surface-border" data-id="element-159">
          <div className="text-center mb-12" data-id="element-160">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-161">
              ¿Qué recibes <span className="text-gold" data-id="element-162">exactamente?</span>
            </h2>
            <p className="font-body text-gray-400 text-lg" data-id="element-163">
              Todo lo que necesitas para transformar tu presencia, empaquetado y
              listo para aplicar.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 items-center mb-16" data-id="element-164">
            <div className="lg:w-1/2 relative" data-id="element-165">
              <div className="absolute -top-6 -right-6 bg-gold text-surface-deepest font-heading font-bold text-lg px-6 py-2 rounded-full shadow-xl z-20 transform rotate-12 border-2 border-surface-deepest" data-id="element-166">
                Libro Digital
              </div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-gold/10 rounded-full blur-[80px] pointer-events-none z-0" data-id="element-167"></div>
              <img src="https://cdn.magicpatterns.com/uploads/19wgf3diFUjrZZ92hQg9WE/e4f93d4d-a72a-46ff-ba17-06b72aa6722c.png" alt="Libro Digital Carisma al Instante" className="w-full max-w-md mx-auto relative z-10 drop-shadow-2xl rounded-lg" data-id="element-168" />
            </div>

            <div className="lg:w-1/2 space-y-6" data-id="element-169">
              <div className="bg-surface-card p-6 rounded-2xl border border-gold/30" data-id="element-170">
                <h3 className="font-heading text-2xl font-bold text-white mb-2" data-id="element-171">
                  Manual Principal: Carisma al Instante
                </h3>
                <p className="font-body text-gray-400 mb-4" data-id="element-172">
                  El protocolo completo con los 17 trucos mentales explicados
                  paso a paso para que los apliques hoy mismo.
                </p>
                <ul className="space-y-2" data-id="element-173">
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-174">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-175" />{' '}
                    Lectura de lenguaje corporal
                  </li>
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-176">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-177" />{' '}
                    Técnicas de contacto visual
                  </li>
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-178">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-179" />{' '}
                    Posicionamiento de alto valor
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* BONUSES */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-180">
            {/* Bonus 1 */}
            <div className="bg-surface-card border border-gold/40 rounded-2xl p-8 relative overflow-hidden shadow-xl shadow-gold/5 group flex flex-col" data-id="element-181">
              <div className="absolute top-0 right-0 bg-gold text-surface-deepest font-bold text-xs px-4 py-1 rounded-bl-lg z-10" data-id="element-182">
                ¡BONO GRATIS!
              </div>

              <div className="flex items-start gap-4 relative z-10 mb-8" data-id="element-183">
                <div className="bg-surface-elevated p-3 rounded-xl border border-gold/20 flex-shrink-0 relative" data-id="element-184">
                  <SmartphoneIcon className="w-8 h-8 text-gold" data-id="element-185" />
                  <div className="absolute inset-0 border border-gold rounded-xl animate-ping opacity-20" data-id="element-186"></div>
                </div>
                <div data-id="element-187">
                  <p className="text-gold font-bold text-sm tracking-widest uppercase mb-1" data-id="element-188">
                    Bono Exclusivo
                  </p>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3 leading-tight" data-id="element-189">
                    ¿Cómo transmitir carisma por redes sociales?
                  </h3>
                  <p className="font-body text-gray-400 leading-relaxed" data-id="element-190">
                    Cómo proyectar un carisma magnético y autoridad sin decir
                    una sola palabra en persona. Resuelve el 50% del problema:
                    tu vida digital y cómo te perciben antes de conocerte.
                  </p>
                </div>
              </div>

              <div className="relative z-10 mt-auto rounded-xl overflow-hidden border border-surface-border shadow-lg" data-id="element-191">
                <img src="https://cdn.magicpatterns.com/uploads/1bDCUt1Kr9mss15pBVWseJ/bono_redes.png" alt="Bono Redes Sociales" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-192" />
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-gradient-to-br from-[#1a1225] via-[#15101f] to-[#0d0a14] border border-purple-500/30 rounded-2xl p-8 relative overflow-hidden shadow-xl shadow-purple-500/5 group flex flex-col" data-id="element-193">
              <div className="absolute top-0 right-0 w-48 h-48 bg-purple-600/10 rounded-full blur-[60px] pointer-events-none" data-id="element-194"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold/5 rounded-full blur-[40px] pointer-events-none" data-id="element-195"></div>
              <div className="absolute top-0 right-0 bg-purple-500 text-white font-bold text-xs px-4 py-1 rounded-bl-lg z-10 flex items-center" data-id="element-196">
                <HeadsetIcon className="w-3 h-3 mr-1" data-id="element-197" /> ¡BONO GRATIS!
              </div>

              <div className="flex items-start gap-4 relative z-10" data-id="element-198">
                <div className="bg-purple-500/10 p-3 rounded-xl border border-purple-500/20 flex-shrink-0" data-id="element-199">
                  <BadgeCheckIcon className="w-8 h-8 text-purple-400" data-id="element-200" />
                </div>
                <div data-id="element-201">
                  <p className="text-purple-400 font-bold text-sm tracking-widest uppercase mb-1" data-id="element-202">
                    Bono de Élite
                  </p>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3 leading-tight" data-id="element-203">
                    Acompañamiento personalizado para tu caso
                  </h3>
                  <p className="font-body text-gray-300 leading-relaxed" data-id="element-204">
                    No estás solo. Resolvemos tus dudas, desbloqueamos tus
                    trabas y personalizamos el protocolo a TU situación real.
                    Línea directa con el especialista.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}